import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon_chevron-right",
  "use": "icon_chevron-right-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 24 24\" id=\"icon_chevron-right\"><path fill=\"currentColor\" d=\"M17.7466 12.7772 8.84572 21.678c-.42928.4293-1.12525.4293-1.55448 0L6.2531 20.6399c-.42854-.4285-.42937-1.1231-.00183-1.5526L13.3053 12 6.25127 4.91274c-.42754-.42955-.42671-1.1241.00183-1.55265l1.03814-1.03813c.42928-.42928 1.12525-.42928 1.55448 0l8.90088 8.90074c.4292.4293.4292 1.1253 0 1.5545Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol